import { Box, makeStyles, Typography } from '@material-ui/core';
import React from 'react';

import { ProviderType } from 'src/constants';
import { Coach } from 'src/models/Common';

import { colors } from '../../../themes/colors';
import CareTeamCard from '../CareTeamCard';
import CareTeamProviderCard from './CareTeamProviderCard';

export interface CoachAssignment {
  uuid: string;
  coach?: Coach;
}

const styles = makeStyles({
  careTeamInfoText: {
    fontWeight: 500,
    fontSize: 14,
    color: colors.gray5,
  },
});

interface Props {
  coachAssignments?: CoachAssignment[];
  providerType: ProviderType;
}
/**
 * This component renders the new design for PAMM providers and also the current design on
 * Care team section.
 *  This will return the new CareTeamProviderCard for PAMM and Therapists providers
 *  and will return the current design with CareTeamCard for coaches
 */
const CareTeamProviders: React.FC<Props> = ({ coachAssignments, providerType }) => {
  const classes = styles();

  /**
   * Renders CareTeamProviderCard with the new design for PAMM and Thereapist providers
   */
  const renderCareTeamProvider = () => {
    const validProviderTypes = [ProviderType.PSYCHIATRIST, ProviderType.THERAPIST];

    return coachAssignments?.map((assignment) => {
      if (validProviderTypes.includes(assignment?.coach?.providerType as ProviderType)) {
        return <CareTeamProviderCard key={assignment.uuid} provider={assignment.coach as Coach} />;
      }

      return null;
    });
  };

  /**
   * Renders CareTeamCard current functionality for coaches if provider is a Coach
   */
  const renderCareTeam = () => {
    return (
      <>
        {coachAssignments?.map((assignment) => {
          if (assignment?.coach?.providerType === ProviderType.COACH) {
            return <CareTeamCard key={assignment.uuid} coach={assignment.coach} />;
          }
          return null;
        })}
        <Box pt={1}>
          <Typography className={classes.careTeamInfoText}>
            All coaching related notes must remain in the Modern Health network. Please only send
            emails To/From the @joinmodernhealth.com domain.
          </Typography>
        </Box>
      </>
    );
  };

  return <>{providerType !== ProviderType.COACH ? renderCareTeamProvider() : renderCareTeam()}</>;
};

export default CareTeamProviders;
